/// <amd-module name="Wit/WorkItemRequirementsLinks/StoryboardUtils" />

import { ILinkIdentifier, IResolvedLinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";
import { LinkTypeFieldIds, ToolIds } from "Wit/WorkItemLinksRegistration/Constants";
import { getLinkTypeDisplayName } from "Wit/WorkItemLinksRegistration/LinkUtils";
import { RegisteredLinkTypeNames } from "Wit/WorkItemLinksRegistration/Constants";

const uncPathPattern = /^(\\{2})([^<>:"\/\\|?*]+)(\\)([^<>:"\/\\|?*]+[$$]?(\\)?)/i;
const fileUrlPattern = /^file:(.+)/i;

/**
 * This is horrible. And apparently it only matches urls with at least one url segment after the
 * domain name like https://www.github.com/something/. I don't know why, but that's what the old
 * web platform code was doing and I don't want to change it.
 */
const httpUrlPattern =
    /^((http|https):\/\/)([^<>:"\/\\|?*]+)(:(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]\d{4}|[1-9]\d{0,3}))?[\/\\]([^<>"\/\\|?*]+)/i;

export function isValidStoryboardUrl(url: string): boolean {
    if (url === "") {
        return false;
    }
    return uncPathPattern.test(url) || fileUrlPattern.test(url) || httpUrlPattern.test(url);
}

export function createStoryboardDisplayData(url: string): IResolvedLinkDisplayData;
export function createStoryboardDisplayData(urlOrIdentifier: ILinkIdentifier): IResolvedLinkDisplayData | undefined;
export function createStoryboardDisplayData(urlOrIdentifier: string | ILinkIdentifier): IResolvedLinkDisplayData | undefined {
    const url = typeof urlOrIdentifier === "string" ? urlOrIdentifier : extractStoryboardUrl(urlOrIdentifier);
    if (!url) {
        return undefined;
    }

    const linkIdentifier = typeof urlOrIdentifier === "string" ? createLinkIdentifier(urlOrIdentifier) : urlOrIdentifier;

    return {
        linkIdentifier,
        icons: [{ iconName: "BacklogBoard" }],
        id: url,
        displayId: "",
        title: url,
        updateDate: linkIdentifier.LastWriteDate,
        uri: url,
        tool: ToolIds.Requirements,
        registeredLinkType: RegisteredLinkTypeNames.Storyboard,
        linkTypeDisplayName: getLinkTypeDisplayName(RegisteredLinkTypeNames.Storyboard)
    };
}

const prefix = "vstfs:///Requirements/Storyboard/";

function extractStoryboardUrl(linkIdentifier: ILinkIdentifier): string | undefined {
    const filePath = linkIdentifier.FilePath;
    if (!filePath || !filePath.startsWith(prefix)) {
        return undefined;
    }

    return decodeURIComponent(filePath.substring(prefix.length));
}

function createLinkIdentifier(url: string): ILinkIdentifier {
    return {
        tool: ToolIds.Requirements,
        FldID: LinkTypeFieldIds.ExternalLink,
        OriginalName: RegisteredLinkTypeNames.Storyboard,
        FilePath: prefix + encodeURIComponent(url)
    };
}
